import styled from 'styled-components'

import Link from '../../../../Link'
import { colors } from '../../../../../constants'

// eslint-disable-next-line import/prefer-default-export
export const Confirmation = styled.div`
    background: ${colors.bluelight};
    border-radius: 5px;
    color: ${colors.white};
    right: 0;
    overflow: hidden;
    padding: 2px 8px;
    position: fixed;
    transform: translateX(1000%);
    transition: all 0.5s;
    z-index: 50;

    ${({ show }) => show && `transform:translateX(0)`}
`

export const StyledLink = styled(Link)`
    flex: 1;
    float: right;
    font-size: 14px;
    margin-right: 10px;
    ${({ width }) => width && `width: ${width};`}
    ${({ noCursor }) => noCursor && `cursor: context-menu;`}

  &:first-child {
        margin-right: 0;
    }
`

export const StyledNoLink = styled.button`
    flex: 1;
    float: right;
    font-size: 14px;
    margin-right: 10px;
    ${({ width }) => width && `width: ${width};`}
    ${({ noCursor }) => noCursor && `cursor: context-menu;`}

    border: none;
    background: inherit;
    padding: 0;
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;

    &:first-child {
        margin-right: 0;
    }
`